import { render, staticRenderFns } from "./TeachingUsage.vue?vue&type=template&id=03b4b94d&scoped=true"
import script from "./TeachingUsage.vue?vue&type=script&lang=js"
export * from "./TeachingUsage.vue?vue&type=script&lang=js"
import style0 from "./TeachingUsage.vue?vue&type=style&index=0&id=03b4b94d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b4b94d",
  null
  
)

export default component.exports